import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {Observable} from 'rxjs';
import * as fromProfile from '../../store/profile.reducers';

@Component({
    selector: 'app-profile-media-word-rank',
    templateUrl: './profile-media-word-rank.component.html',
    styleUrls: ['./profile-media-word-rank.component.scss'],
    standalone: false
})
export class ProfileMediaWordRankComponent implements OnInit {

  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
  }

}
